import { combineReducers } from 'redux';
import auth from './auth';
import system from './system';
import user from './user';

export default combineReducers({ auth, system, user });
